import config from "./../config";
import core from "./../core";
import { map, groupBy, concat, find, findLast, filter } from "lodash";
const app = {};
app.isSetWebview = function () {
  let cookieWEBVIEW = window.source === config.WEBVIEW_KEY;
  if (cookieWEBVIEW) {
    config.IS_WEBVIEW = true;
  } else {
    config.IS_WEBVIEW = false;
  }

  return config.IS_WEBVIEW;
};

app.resetBracket = (arrContraintsDefault) => {
  let arrContraints = [];
  for (let i = 0; i < arrContraintsDefault.length; i++) {
    let objStage = arrContraintsDefault[i];
    const { name, subStage } = objStage.stage;
    let arrSubstage = [];
    for (let j = 0; j < (subStage || []).length; j++) {
      let objSubStage = subStage[j];
      const { team, teamSelection } = objSubStage;
      let arrTeamSelection = [];
      let arrTeam = [];
      for (let jN = 0; jN < (team || []).length; jN++) {
        let objTeam = team[jN];
        arrTeam.push({ ...objTeam });
      }
      if (name === config.enumStage.teamSelection) {
        for (let jN = 0; jN < (teamSelection || []).length; jN++) {
          let objTeam = teamSelection[jN];
          arrTeamSelection.push({ ...objTeam });
        }
      }
      let pushSbstage = { ...objSubStage, team: arrTeam };
      if (arrTeamSelection.length) {
        pushSbstage.teamSelection = arrTeamSelection;
      }
      arrSubstage.push(pushSbstage);
    }
    arrSubstage = arrSubstage.sort((a, b) => {
      let valueA = a.name;
      let valueB = b.name;

      if (valueA > valueB) {
        return 1;
      }
      if (valueA < valueB) {
        return -1;
      }
      return 0;
    });
    arrContraints.push({
      ...objStage,
      stage: { ...objStage.stage, name: name, subStage: arrSubstage },
    });
  }
  return arrContraints;
};

//======================Tracking======================
app.googleAnalyticsTracking = function (sTitle, sPath) {
  let fResp = false;
  if (window.lastPath !== sPath) {
    if (window.gtag) {
      window.gtag("config", config.GA_TRACKING_ID, {
        page_title: sTitle,
        page_path: sPath,
      });
      window.lastPath = sPath;
    }
    window.lastPath = sPath;
    fResp = true;
  }
  return fResp;
};
app.googleAnalyticsEventTracking = function (
  action,
  category,
  opt_label,
  objExtra
) {
  let cookie = app.getLoginCookie();
  let deviceType = core.isMobile()
    ? "Mobile"
    : core.isTablet()
    ? "Tablet"
    : "Desktop";
  let browser = core.getBrowser(window.navigator.userAgent);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let platform = urlParams.get("source");
  let platform_type = "web";
  let tournament = "IPL_2025";
  const appType = app.getAppType();
  if (appType === config.enumWebView.android) {
    platform_type = "android";
  } else if (appType === config.enumWebView.ios) {
    platform_type = "ios";
  }
  // let utmParamObj = app.addUTMParameters();

  let ObjEventParam = {
    device_category: deviceType,
    label: opt_label,
    browser: browser,
    platform: platform,
    platform_type: platform_type,
    category: category,
    tournament: tournament,
    //...utmParamObj
  };
  if (objExtra) {
    ObjEventParam = { ...ObjEventParam, ...objExtra };
  }
  if (cookie) {
    let userId = cookie.SocialId ? cookie.SocialId : null;
    ObjEventParam.userId = userId;
  }

  if (window.gtag) {
    /* window.gtag("event", action, {
      event_category: category,
      event_label: opt_label,
    }); */
  }
  // console.log(action, ObjEventParam);

  // if (window.D11Data) {
  // console.log(action, ObjEventParam);
  // window.D11Data.track(action, ObjEventParam);
  // }
  // console.dir(action, ObjEventParam);
};
app.TrackGoogleAnalyticsEventByObj = function (obj, objExtra = {}) {
  if (obj) {
    false &&
      app.googleAnalyticsEventTracking(
        obj.action,
        obj.category,
        obj.label,
        objExtra
      );
  }
};
// app.d11DataTracking = function (sEventName, ObjEventParam) {
//   if (window.D11Data) {
//     let cookie = app.getLoginCookie();
//     let deviceType = core.isMobile()
//       ? "Mobile"
//       : core.isTablet()
//       ? "Tablet"
//       : "Desktop";
//     let browser = core.getBrowser(window.navigator.userAgent);
//     const queryString = window.location.search;
//     const urlParams = new URLSearchParams(queryString);
//     let platform = urlParams.get("source");
//     // let platform = "seasonlong";
//     let platform_type = "web";
//     const appType = app.getAppType();
//     if (appType === config.enumWebView.android) {
//       platform_type = "android";
//     } else if (appType === config.enumWebView.ios) {
//       platform_type = "ios";
//     }
//     const ObjEventParamExtra = {
//       ...ObjEventParam,
//       device_category: deviceType,
//       browser: browser,
//       platform,
//       platform_type,
//     };
//     if (cookie) {
//       let userId = cookie.SocialId ? cookie.SocialId : null;
//       ObjEventParamExtra.userId = userId;
//     }
//     window.D11Data.track(sEventName, ObjEventParamExtra);
//   }
//   ////console.warn("sEventName = ", sEventName, 'ObjEventParam: ', ObjEventParam)
// };
app.addUTMParameters = (ObjEventParam = {}) => {
  const objUrl = core.getQueryParams(window.location.href);
  if (objUrl) {
    ObjEventParam.utm_source =
      objUrl && objUrl.utm_source ? objUrl.utm_source : null;
    ObjEventParam.utm_campaign =
      objUrl && objUrl.utm_campaign ? objUrl.utm_campaign : null;
    ObjEventParam.utm_content =
      objUrl && objUrl.utm_content ? objUrl.utm_content : null;
    ObjEventParam.utm_medium =
      objUrl && objUrl.utm_medium ? objUrl.utm_medium : null;
  }
  return ObjEventParam;
};
//======================Tracking======================

app.getLoginCookie = function () {
  let cookie = core.getCookie(config.COOKIE_FANTASY);
  let returnCookie = null;
  try {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let parsedCookie = JSON.parse(cookie);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  } catch (error) {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let cookieSpecial = cookie.replace(
        /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,
        ""
      );
      let parsedCookie = JSON.parse(cookieSpecial);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }

    return returnCookie;
  }
};
app.getLoginCookieStatus = () => {
  let parentCookie = core.getCookie(config.COOKIE_PARENT);
  let fantasyCookie = core.getCookie(config.COOKIE_FANTASY);
  let ret = config.enumLoginCookie.bothNotPresent;
  if (!parentCookie && !fantasyCookie) {
    ret = config.enumLoginCookie.bothNotPresent;
  } else if (parentCookie && fantasyCookie) {
    ret = config.enumLoginCookie.bothPresent;
  } else if (parentCookie && !fantasyCookie) {
    // only Fifa cookie present.
    ret = config.enumLoginCookie.parentPresent;
  } else if (!parentCookie && fantasyCookie) {
    // only Fantasy cookie present.
    ret = config.enumLoginCookie.fantasyPresent;
  }

  return ret;
};

app.eventValidators = (el, cookie) => {
  let resp = true;
  return resp;
};

app.eventValidatorsLoggedInWithBracket = (el, cookie, arrPlayedGamedays) => {
  let resp = false;
  if (
    cookie &&
    !Number(cookie.isAnonymous) &&
    arrPlayedGamedays &&
    arrPlayedGamedays.length
  ) {
    // if (arrPlayedGamedays && arrPlayedGamedays.length && arrPlayedGamedays.indexOf(config.enumGameStage.knockoutStage) > -1) {
    resp = true;
  }
  return resp;
};

app.eventValidatorsGameplayLocked = (el, cookie, userEotStatus) => {
  let resp = true;
  if (userEotStatus == config.enumEotScenarios.no_eot) {
    resp = app.eventValidatorsLoggedIn(el, cookie);
  } else {
    resp = false;
  }
  return resp;
};

app.eventValidatorsGameLocked = (el, cookie, userEotStatus) => {
  let resp = true;
  if (userEotStatus == config.enumEotScenarios.no_eot) {
    resp = app.eventValidatorsLoggedIn(el, cookie);
  } else if (
    userEotStatus == config.enumEotScenarios.logged_out_user ||
    userEotStatus == config.enumEotScenarios.logged_in_without_team
  ) {
    resp = false;
  }
  return resp;
};

app.eventValidatorsLocked = (el, cookie, isGameStatus) => {
  let resp = true;
  if (
    !(cookie && Number(cookie.HasTeam)) &&
    isGameStatus !== config.enumGameStatus.open
  ) {
    resp = false;
  }
  return resp;
};
app.eventValidatorsLoggedIn = (el, cookie) => {
  let resp = false;
  if (cookie) {
    resp = true;
  }
  return resp;
};

app.deleteAllCookies = (reloadPage) => {
  var cookies = document.cookie.split(";");
  let exDate = new Date();
  exDate.setDate(exDate.getDate() + -1);
  app.deleteAllLocalStorage();
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

    document.cookie =
      name +
      "=;expires=" +
      exDate.toUTCString() +
      ";domain=" +
      config.sDomain +
      ";path=/";

    document.cookie = name + "=;expires=" + exDate.toUTCString() + ";path=/";
  }
  //
  //core.removeLocalStorageValue(config.enumCookie.inviteCookie);
  if (reloadPage) {
    window.location.reload();
  }
};

app.deleteAllLocalStorage = () => {
  core.removeLocalStorageValue(config.tempSelectedPlayerCookieName);
  core.removeLocalStorageValue(config.tempTeamGamedayId);
  core.removeLocalStorageValue(config.tempTeamObjBooster);
  core.removeLocalStorageValue(config.cookie.leaguesCount);
  core.removeLocalStorageValue(config.badgesStorage);
  core.removeLocalStorageValue(config.createTeamStorage);
  localStorage.removeItem("accessToken");
};

app.creteEmptyTeamFormation = (objFormation, trans) => {
  let arrSelectedPlayer = [];
  const jDfCount = objFormation ? objFormation.DEF : 0;
  const jMfCount = objFormation ? objFormation.MID : 0;
  const jFwCount = objFormation ? objFormation.FWD : 0;
  const jGkCount = 1;
  let arrSelectedPlayerMain = {};
  //Forward Row
  for (let j = 0; j < jFwCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.forwards ? trans.forwards : "Forwards",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.forwards,
      jorder: j + 1,
      skillNameShort: (trans && trans.fwd ? trans.fwd : "FWD").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.forwards] = arrSelectedPlayer;
  //MidFielders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jMfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.midfielders ? trans.midfielders : "Midfielders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.midfielders,
      jorder: j + 1,
      skillNameShort: (trans && trans.mid ? trans.mid : "MID").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.midfielders] = arrSelectedPlayer;
  //Defenders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jDfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.defenders ? trans.defenders : "Defenders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.defenders,
      jorder: j + 1,
      skillNameShort: (trans && trans.def ? trans.def : "DEF").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.defenders] = arrSelectedPlayer;
  //GoalKeepers Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jGkCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.goalkeepers ? trans.goalkeepers : "Goalkeepers",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.goalkeepers,
      jorder: j + 1,
      skillNameShort: (trans && trans.gk ? trans.gk : "GK").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.goalkeepers] = arrSelectedPlayer;
  return arrSelectedPlayerMain;
};
app.creatrNewSkillRow = (arrSkillOld, arrSkillNew, jAvoidFiltreIndex) => {
  for (let jN = 0; jN < (arrSkillOld || []).length; jN++) {
    const objRowOld = arrSkillOld[jN];
    for (let jNDex = 0; jNDex < (arrSkillNew || []).length; jNDex++) {
      const objRowNew = arrSkillNew[jNDex];
      if (
        jAvoidFiltreIndex !== objRowOld.filterIndex &&
        objRowNew.filterIndex === config.emptyValue
      ) {
        objRowNew.filterIndex = objRowOld.filterIndex;
        break;
      }
    }
  }
  return arrSkillNew;
};
app.getCurrentSelectedTabIndexes = (
  jSkillP,
  arrSkillFiltreTab,
  arrSelectedPlayer
) => {
  let jSkillFiltreTab = jSkillP;
  let jSkillFiltreTabPlayer = -1;
  loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const objSkill = arrSkillFiltreTab[j];
    const jSkillKey = objSkill.id;
    const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
    //
    const arrSkillNew = [];
    const arrSkillNewEmpty = [];
    for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
      let objSkill = arrSelectedPlayerBySkill[jN];
      if (objSkill.filterIndex === config.emptyValue) {
        arrSkillNewEmpty.push({ ...objSkill });
      } else {
        arrSkillNew.push({ ...objSkill });
      }
    }
    for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
      let objSkill = arrSkillNewEmpty[jN];
      arrSkillNew.push({ ...objSkill });
    }
    //
    for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
      const objPlayer = arrSkillNew[jN];
      if (objPlayer.filterIndex === config.emptyValue) {
        if (
          (!jSkillFiltreTab && jSkillFiltreTab !== 0) ||
          jSkillFiltreTab <= j
        ) {
          jSkillFiltreTab = j;
          jSkillFiltreTabPlayer = jN;
          break loop1;
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
      const objSkill = arrSkillFiltreTab[j];
      const jSkillKey = objSkill.id;
      const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
      //
      const arrSkillNew = [];
      const arrSkillNewEmpty = [];
      for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
        let objSkill = arrSelectedPlayerBySkill[jN];
        if (objSkill.filterIndex === config.emptyValue) {
          arrSkillNewEmpty.push({ ...objSkill });
        } else {
          arrSkillNew.push({ ...objSkill });
        }
      }
      for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
        let objSkill = arrSkillNewEmpty[jN];
        arrSkillNew.push({ ...objSkill });
      }
      //
      for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
        const objPlayer = arrSkillNew[jN];
        if (objPlayer.filterIndex === config.emptyValue) {
          if (jSkillFiltreTab > j) {
            jSkillFiltreTab = j;
            jSkillFiltreTabPlayer = jN;
            break loop1;
          }
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    jSkillFiltreTab = config.emptyValue;
    jSkillFiltreTabPlayer = config.emptyValue;
  }
  return {
    jSkillFiltreTab: jSkillFiltreTab,
    jSkillFiltreTabPlayer: jSkillFiltreTabPlayer,
  };
};

app.isPlayerFromSelection = (
  arrSelectedPlayer,
  sKeyToSearch,
  sValueToSearch
) => {
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrSelectedPlayer,
    sKeyToSearch,
    sValueToSearch
  );
  const isSelected = jIndexSelectedPlayer === -1 ? false : true;
  return isSelected;
};
app.getPlayerDetailsById = (arrPlayers, jId) => {
  let objPlayer = null;
  if (jId) {
    objPlayer = arrPlayers && arrPlayers.find((ele) => ele.Id === jId);
  }
  return objPlayer;
};
app.breakRefInSelection = (arrSelectedPlayer) => {
  let arrSelectedPlayerMain = {};
  for (let jKey in arrSelectedPlayer) {
    const arrSkill = arrSelectedPlayer[jKey];
    let arrSkillNew = [];
    for (let jN = 0; jN < (arrSkill || []).length; jN++) {
      let objSkill = arrSkill[jN];
      arrSkillNew.push({ ...objSkill });
    }
    arrSelectedPlayerMain[jKey] = arrSkillNew;
  }
  return arrSelectedPlayerMain;
};
app.getFilledCountOfPlayerSelectionBySkill = (arrSelectedPlayer, jSKill) => {
  let jCount = 0;
  const arrSkill = arrSelectedPlayer[jSKill];
  for (let jNDex = 0; jNDex < (arrSkill || []).length; jNDex++) {
    const objRowNew = arrSkill[jNDex];
    if (config.emptyValue !== objRowNew.filterIndex) {
      jCount = jCount + 1;
    }
  }
  return jCount;
};
app.getGenerateImage = function (sLink, callback) {
  let sUrl = sLink;
  let obj = {
    url: sUrl,
    method: "get",
    params: {},
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};
app.getGenerateImageResult = function (formationId, callback) {
  let sUrl = config.shreGenerateImageResult;
  let obj = {
    url: sUrl,
    method: "get",
    params: {
      formationId: formationId,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

//
app.getSelectedFixture = (arrFixtures, jFixtures) => {
  let objFixture = null;
  if (arrFixtures && arrFixtures.length) {
    objFixture = arrFixtures[jFixtures];
  }
  return objFixture;
};
app.getSelectedPosition = (arrSkillFiltreTab, jSkillFiltreTab) => {
  let objSkillFiltreTab = null;
  if (arrSkillFiltreTab && arrSkillFiltreTab.length) {
    objSkillFiltreTab = arrSkillFiltreTab[jSkillFiltreTab];
  }
  return objSkillFiltreTab;
};

app.getFixtureStatusByRow = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.IsLocked == 0 && element.IsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  } else if (element.IsLocked == 0 && element.IsCurrent == 1) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.IsLocked == 1 &&
    /* element.IsLive == 0 && */ element.IsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (element.IsCurrent == 2 && element.IsLocked == 1) {
    /* else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } */
    /*else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } */
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.IsCurrent == 3 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  } else if (element.IsCurrent == 4 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isPostponed;
  } else if (element.IsCurrent == 5) {
    sMatchStatus = config.enumFixtureType.isPostMatchAbandoned;
  }

  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};

app.getFixtureStatusByMatches = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.MhIsLocked == 0 && element.MhIsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  }
  //(if gameday is open)
  else if (
    element.IsLocked == 0 &&
    element.IsCurrent == 1 &&
    element.MhIsLocked == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.MhIsLocked == 1 &&
    element.IsLive == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } else if (element.MhIsCurrent == 2 && element.MhIsLocked == 1) {
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.MhIsCurrent == 3 && element.MhIsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  } else if (element.MhIsCurrent == 4 && element.MhIsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isPostponed;
  } else if (element.IsCurrent == 5) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isPostMatchAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};
app.getFixtureStatusByRowPlayerCard = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.IsLocked == 0 && element.IsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  } else if (element.IsLocked == 0 && element.IsCurrent == 1) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (Number(element.MatchStatus) === 3) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } else if (
    element.IsLocked == 1 &&
    /* element.IsLive == 0 && */ element.IsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (element.IsCurrent == 2 && element.IsLocked == 1) {
    /*else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } */
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.IsCurrent == 3 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  } else if (element.IsCurrent == 4 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isPostponed;
  } else if (element.IsCurrent == 5) {
    sMatchStatus = config.enumFixtureType.isPostMatchAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};
app.getGdForMatchFile = (allFixtures) => {
  let obj = {};
  for (let jFixture = 0; jFixture < allFixtures.length; jFixture++) {
    let rowFixtures = allFixtures[jFixture];
    let matchFileName = rowFixtures.MatchFile;
    let matchGD = rowFixtures.TeamGamedayId;
    if (matchFileName) {
      obj[matchFileName] = matchGD;
    }
  }
  return obj;
};

app.getTourStatus = (finalMatch, ftgdid) => {
  let status = config.enumEotScenarios.no_eot;
  if (finalMatch) {
    let objCookie = app.getLoginCookie();
    let isValidUser = objCookie && objCookie.SocialId;
    let firstGD = ftgdid ? ftgdid : 0;
    let HasTeamForFinal = firstGD && firstGD <= finalMatch.TeamGamedayId;
    let isFinalLive =
      finalMatch.IsFixtureAnnounce ==
      config.isAnnouncedStatus.tour_last_match_live;
    let isFinalEnded =
      finalMatch.IsFixtureAnnounce == config.isAnnouncedStatus.tour_ended ||
      finalMatch.IsGDAbandoned == 1;

    if (isFinalLive || isFinalEnded) {
      if (isValidUser) {
        if (HasTeamForFinal) {
          if (isFinalLive) {
            status = config.enumEotScenarios.logged_in_with_live_team;
          } else {
            status = config.enumEotScenarios.logged_in_with_team;
          }
        } else {
          status = config.enumEotScenarios.logged_in_without_team;
        }
      } else {
        status = config.enumEotScenarios.logged_out_user;
      }
    }
  }
  return status;
};

app.generateFixtureArray = (lstFixturesP) => {
  let lstFixtures = lstFixturesP;
  //console.log(lstFixtures);
  let arrRound = [];
  for (let jFixture = 0; jFixture < lstFixtures.length; jFixture++) {
    let rowFixtures = lstFixtures[jFixture];
    // let webMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmmm');
    // let mobMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmm');
    // let webDate = core.dateFormat(rowFixtures.Deadlinedate, 'd');
    // let S = /*(dateLabel[webDate] ? dateLabel[webDate] : 'th');//*/core.dateFormat(rowFixtures.DateTime, 'S');
    // let sDate = core.dateFormat(rowFixtures.Deadlinedate, 'dd/mm/yyyy hh:MM TT');
    let jDayNo = rowFixtures.Matchday;
    let TeamGamedayId = rowFixtures.TeamGamedayId
      ? +rowFixtures.TeamGamedayId
      : 0;
    let jRound = core.getIndexOfArrayByValue(
      arrRound,
      "TeamGamedayId",
      TeamGamedayId
    );
    if (jRound === -1) {
      let arrDetails = [{ ...rowFixtures }];
      arrRound.push({
        ...rowFixtures,
        arrDetails: arrDetails,
      });
    } else {
      let arrDetails = arrRound[jRound].arrDetails;
      arrDetails.push({ ...rowFixtures });
    }
  }
  return arrRound;
};
app.getMatchDetailsById = (arrFixtures, jId) => {
  let objMatch = null;
  if (jId) {
    loop1: for (let j = 0; j < (arrFixtures || []).length; j++) {
      let objRow = arrFixtures[j];
      for (let jN = 0; jN < (objRow.arrDetails || []).length; jN++) {
        let ele = objRow.arrDetails[jN];
        if (ele.MatchId === jId) {
          objMatch = ele;
          break loop1;
        }
      }
    }
  }
  return objMatch;
};
app.isPointCalDone = (arrFixture) => {
  let isMatchFinished = false;
  for (let j = 0; j < (arrFixture || []).length; j++) {
    let obj = arrFixture[j];
    if (obj) {
      let sMatchStatus = app.getFixtureStatusByRow(obj);
      if (sMatchStatus === config.enumFixtureType.isFinished) {
        isMatchFinished = true;
        break;
      }
    }
  }
  return isMatchFinished;
};

app.getMyFirstFixture = (arrFixture, ftgid) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let myFirstFix = find(arrFixture || [], (f) => {
    return f.TeamGamedayId == firstGD;
  });

  if (myFirstFix) {
    let status = app.getFixtureStatusByRow(myFirstFix);
    obj = {
      fixture: myFirstFix,
      status: status,
    };
  }

  return obj;
};

app.getRecentFixture = (arrFixture, ftgid, liveOnly) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let filteredFixtures = filter(arrFixture || [], (f) => {
    return f.TeamGamedayId >= firstGD;
  });

  if (filteredFixtures && filteredFixtures.length) {
    let openGamedays = find(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isOpen;
    });
    if (openGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(openGamedays);
      obj = {
        fixture: openGamedays,
        status: status,
      };
    }

    let postGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isFinished;
    });
    if (postGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(postGamedays);
      obj = {
        fixture: postGamedays,
        status: status,
      };
    }

    let liveGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return (
        status == config.enumFixtureType.isLock ||
        status == config.enumFixtureType.isLive ||
        status == config.enumFixtureType.isEnded
      );
    });
    if (liveGamedays) {
      let status = app.getFixtureStatusByRow(liveGamedays);
      obj = {
        fixture: liveGamedays,
        status: status,
      };
    }
  }

  return obj;
};

app.isFoundPlayerFromFilter = (arrFiltresTab, ele, arrFixtures) => {
  let fFound = true;
  let arrFound = [];
  for (let j = 0; j < (arrFiltresTab || []).length; j++) {
    const objRow = arrFiltresTab[j];
    let arrDetails = objRow.arrDetails;
    for (let jN = 0; jN < (arrDetails || []).length; jN++) {
      const objFilter = arrDetails[jN];
      if (objFilter.checked) {
        fFound = false;
        //console.log(objRow, objFilter);
        if (objRow.id === config.enumTabsId.teams) {
          if (objFilter.id === ele.TeamId) {
            fFound = true;
            break;
          }
        } else if (objRow.id === config.enumTabsId.matches) {
          const objMatch = app.getMatchDetailsById(arrFixtures, objFilter.id);
          if (objMatch) {
            if (
              objMatch.HomeTeamId === ele.TeamId ||
              objMatch.AwayTeamId === ele.TeamId
            ) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.nationality) {
          if (objFilter.id === config.enumNationalityIds.foreign) {
            if (Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          } else if (objFilter.id === config.enumNationalityIds.indian) {
            if (!Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.creditRange) {
          if (
            (objFilter.min === -1 || ele.Value > objFilter.min) &&
            (objFilter.max === -1 || ele.Value < objFilter.max)
          ) {
            fFound = true;
            break;
          }
        } else if (objRow.id === config.enumTabsId.skill) {
          if (objFilter.id == ele.SkillId) {
            fFound = true;
            break;
          }
        } else if (objRow.id === config.enumTabsId.uncap) {
          if (objFilter.id === config.enumCapFilterIds.uncap) {
            if (ele && Number(ele[config.enumApiKeys.isUncap])) {
              fFound = true;
              break;
            }
          } else if (objFilter.id === config.enumCapFilterIds.cap) {
            if (!(ele && Number(ele[config.enumApiKeys.isUncap]))) {
              fFound = true;
              break;
            }
          }
        }
      }
    }
    arrFound.push(fFound);
  }
  for (let j = 0; j < arrFound.length; j++) {
    let row = arrFound[j];
    if (!row) {
      fFound = false;
    }
  }
  return fFound;
};
app.getRenderPlayers = (arrSelectedPlayer) => {
  let objRenderPlayer = {
    [config.enumPosition.wk]: [],
    [config.enumPosition.bat]: [],
    [config.enumPosition.ar]: [],
    [config.enumPosition.bowl]: [],
  };
  for (let j = 0; j < arrSelectedPlayer.length; j++) {
    const objPlayer = arrSelectedPlayer[j];
    const isInSkillRange = config.enumPositionText[objPlayer.SkillId];
    if (isInSkillRange) {
      objRenderPlayer[objPlayer.SkillId].push(objPlayer);
    }
  }
  return objRenderPlayer;
};
app.getPlayerDetails = (arrPlayerListing, Id, arrUserTeamPlayerList) => {
  let arrUserTeamPlayerListT = arrUserTeamPlayerList;
  let arrPlayerListingT = arrPlayerListing;
  if (!arrPlayerListing) {
    arrPlayerListingT = [];
  }
  if (!arrUserTeamPlayerList) {
    arrUserTeamPlayerListT = [];
  }
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrPlayerListingT,
    "Id",
    Id
  );
  let objMain = arrPlayerListingT[jIndexSelectedPlayer];
  objMain = objMain ? objMain : {};
  const jIndexTeamPlayer = core.getIndexOfArrayByValue(
    arrUserTeamPlayerListT,
    "id",
    Id
  );
  let objMainTeam = arrUserTeamPlayerListT[jIndexTeamPlayer];
  objMainTeam = objMainTeam ? objMainTeam : {};
  return { ...objMain, ...objMainTeam };
};
app.getSelectedCountBySkill = (arrSelectedPlayerP) => {
  let jWkLength = 0;
  let jBtLength = 0;
  let jBlLength = 0;
  let jArLength = 0;
  let arrSelectedPlayer = arrSelectedPlayerP;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPosition = arrSelectedPlayer[j];
    if (rowPosition.Id !== config.emptyValue) {
      if (rowPosition.SkillId === config.enumPosition.wk) {
        jWkLength = jWkLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bat) {
        jBtLength = jBtLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bowl) {
        jBlLength = jBlLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.ar) {
        jArLength = jArLength + 1;
      }
    }
  }

  return {
    jWkCount: jWkLength,
    jBtCount: jBtLength,
    jBlCount: jBlLength,
    jArCount: jArLength,
  };
};
app.getMaxMinValidation = (
  arrSelectedPlayer,
  jSkill,
  jSkillMaxLength,
  jMaxTeamCount
) => {
  let objReturn = {};
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  //MAX
  let jCurrentSkillLength = 0;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPlayer = arrSelectedPlayer[j];
    if (rowPlayer.SkillId === jSkill) {
      jCurrentSkillLength = jCurrentSkillLength + 1;
    }
  }
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  objReturn = { wkMin: wkMin, batMin: batMin, bowlMin: bowlMin, arMin: arMin };
  if (jSkillMaxLength <= jCurrentSkillLength) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.max };
  }
  //check for minimum positions.
  else if (jMaxTeamCount - 1 < jAvailableSkillPlace) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.min };
  }
  return objReturn;
};
app.addInTeamSelection = (
  arrSelectedPlayer,
  jPlayerId,
  jSkill,
  jMaxTeamCountT,
  isCaptain,
  isViceCaptain
) => {
  let flag = false;
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  let jAvailableSkillPlaceT = jAvailableSkillPlace;
  if (jSkill === config.enumPosition.wk) {
    jAvailableSkillPlaceT = batMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bat) {
    jAvailableSkillPlaceT = wkMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bowl) {
    jAvailableSkillPlaceT = wkMin + batMin + arMin;
  } else if (jSkill === config.enumPosition.ar) {
    jAvailableSkillPlaceT = wkMin + batMin + bowlMin;
  }
  if (jMaxTeamCountT > jAvailableSkillPlaceT) {
    for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
      let rowPlayer = arrSelectedPlayer[j];
      if (
        rowPlayer.Id === config.emptyValue &&
        rowPlayer.defaultSkillId === jSkill
      ) {
        rowPlayer.Id = jPlayerId;
        rowPlayer.SkillId = jSkill;
        if (isCaptain) {
          rowPlayer.isCaptain = isCaptain;
        } else if (isViceCaptain) {
          rowPlayer.isViceCaptain = isViceCaptain;
        }
        flag = true;
        break;
      }
    }
    if (!flag) {
      for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
        let rowPlayer = arrSelectedPlayer[j];
        if (
          rowPlayer.Id ===
          config.emptyValue /*  && rowPlayer.defaultSkillId === config.enumPosition.ar */
        ) {
          rowPlayer.Id = jPlayerId;
          rowPlayer.SkillId = jSkill;
          if (isCaptain) {
            rowPlayer.isCaptain = isCaptain;
          } else if (isViceCaptain) {
            rowPlayer.isViceCaptain = isViceCaptain;
          }
          flag = true;
          break;
        }
      }
    }
  }
  return {
    flag: flag,
    arrSelectedPlayer: arrSelectedPlayer,
  };
};
app.switchExistingFormation = (
  objPlayer,
  jSkillP,
  arrSelectedPlayer,
  players,
  jMaxTeamCount,
  isIgnore
) => {
  let objReturn = {
    retVal: config.enumSwitchType.none,
  };
  const SecondarySkillId =
    jSkillP === Number(objPlayer.SkillId)
      ? Number(objPlayer.SecondarySkillId)
      : Number(objPlayer.SkillId);
  const jPlayerId = Number(objPlayer.Id);
  let hasSecSkill = config.enumMaxPositionNos[SecondarySkillId];
  let flag = false;
  let jSkill = jSkillP;
  let jSkillMaxLength = config.enumMaxPositionNos[jSkill]
    ? config.enumMaxPositionNos[jSkill]
    : 0;
  let objMaxMinValidation = app.getMaxMinValidation(
    arrSelectedPlayer,
    jSkill,
    jSkillMaxLength,
    jMaxTeamCount
  );
  if (objMaxMinValidation.retVal === config.enumMinMaxType.max) {
  } else if (objMaxMinValidation.retVal === config.enumMinMaxType.min) {
  } else {
    //add
    const objSelectionAdded = app.addInTeamSelection(
      arrSelectedPlayer,
      jPlayerId,
      jSkill,
      jMaxTeamCount
    );
    flag = objSelectionAdded.flag;
    arrSelectedPlayer = objSelectionAdded.arrSelectedPlayer;
    objReturn = {
      retVal: config.enumSwitchType.changeSource,
      arrSelectedPlayer: arrSelectedPlayer,
      flag: flag,
    };
  }

  return objReturn;
};
app.getSkillShortNameBySillId = (arrSkillFiltreTab, SkillId) => {
  let objSkillFiltreTab = null;
  let SkillShortName = "";
  for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const rowObj = arrSkillFiltreTab[j];
    if (rowObj.SkillId === SkillId) {
      SkillShortName = rowObj.SkillShortName;
      break;
    }
  }
  return SkillShortName;
};
app.converToCurrencyFormat = (number, flag) => {
  if (number) {
    var integer = flag ? Number(number).toFixed(1) : Number(number);
    /* var num = integer.toString();
    var decimalArr = num.split("."); // for decimal
    var numArr = decimalArr[0].split("");
    var count = 0;
    var newArr = [];
    for (var i = numArr.length - 1; i >= 0; i--) {
      newArr.unshift(numArr[i]);
      if (count % 2 == 0 && !(count == 0 || count == numArr.length - 1)) {
        newArr.unshift(",");
      }
      count++;
    }
    return newArr.join("") + (decimalArr[1] ? "." + decimalArr[1] : ""); */
    number = integer.toLocaleString ? integer.toLocaleString("en-IN") : number;
  }
  return number;
};

app.converToCurrencyFormatWithDecimal = (integer, noOfDecimalPlace) => {
  let number = Number(integer)
    .toFixed(noOfDecimalPlace)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return number;
};

app.convertToKOrLacs = (number, noOfDecimalPlace) => {
  var result;
  if (number >= 1000000) {
    // If number is equal to or greater than 100000, convert to Lacs
    result = (number / 100000).toFixed(noOfDecimalPlace) + " Lacs";
  } else if (number >= 1000) {
    // If number is equal to or greater than 1000, convert to K
    result = (number / 1000).toFixed(noOfDecimalPlace) + " K";
  } else {
    // If number is less than 1000, return the original number
    result = number;
  }
  return result;
};

app.getFilteredContestPlayerAndPoints = (arrFiltresTab, players, selector) => {
  let arrFilteredPlayer = [];
  let changes = {
    nation: [],
    credit: { min: [], max: [] },
    team: [],
    skill: [],
    unCap: [],
    matches: [],
  };
  if (players) {
    arrFiltresTab.map(({ transKey, id: aId, arrDetails }) => {
      arrDetails.map((arr) => {
        // arr.tempChecked ||
        if (arr.tempChecked || arr.checked) {
          arrFilteredPlayer = players;
          //TODO:use enum
          if (aId === config.enumTabsId.teams) {
            changes.team.push(arr.id);
          }
          if (aId === config.enumTabsId.matches) {
            changes.matches.push(arr.value.split(" ")?.[0]);
            changes.matches.push(arr.value.split(" ")?.[2]);
          }

          if (aId === config.enumTabsId.nationality) {
            // FIXME: use enum

            if (arr.id === config.enumNationalityIds.indian) {
              changes.nation.push(0);
            } else {
              changes.nation.push(1);
            }
          }
          if (aId === config.enumTabsId.creditRange) {
            changes.credit.min.push(arr.min);
            changes.credit.max.push(arr.max);
          }
          if (aId === config.enumTabsId.skill) {
            changes.skill.push(arr.id);
          }
          if (aId === config.enumTabsId.uncap) {
            if (arr.id === config.enumCapFilterIds.cap) {
              changes.unCap.push(0);
            } else {
              changes.unCap.push(1);
            }
          }
          if (changes.team.length) {
            arrFilteredPlayer = players.filter((player) => {
              if (selector === "Players") {
                return changes.team.includes(player.teamid);
              } else if (selector === "Points") {
                return changes.team.includes(player.TeamId);
              }
            });
          }
          if (changes.matches.length) {
            arrFilteredPlayer = players.filter((player) => {
              if (selector === "Players") {
                return changes.matches.includes(player.tmshrtnm);
              } else if (selector === "Points") {
                return changes.matches.includes(player.tmshrtnm);
              }
            });
          }
          if (changes.nation.length) {
            arrFilteredPlayer = arrFilteredPlayer.filter((player) =>
              changes.nation.includes(parseInt(player.isfp))
            );
          }

          if (changes.credit.min.length) {
            arrFilteredPlayer = arrFilteredPlayer.filter((player) => {
              for (let i = 0; i < changes.credit.min.length; i++) {
                if (
                  changes.credit.min[i] <= +player.value &&
                  (+player.value <= changes.credit.max[i] ||
                    changes.credit.max[i] === -1)
                ) {
                  return player;
                }
              }
            });
          }
          if (changes.skill.length) {
            arrFilteredPlayer = arrFilteredPlayer.filter((player) =>
              changes.skill.includes(parseInt(player.sklid))
            );
          }
          if (changes.unCap.length) {
            arrFilteredPlayer = arrFilteredPlayer.filter((player) =>
              changes.unCap.includes(parseInt(player.isuncap))
            );
          }
        }
      });
    });

    if (selector === "Players") {
      arrFilteredPlayer.sort((a, b) => b.ovrpoint - a.ovrpoint);
    } else if (selector === "Points") {
      arrFilteredPlayer.sort((a, b) => b.OverallPoints - a.OverallPoints);
    }
  }

  if (selector === "Players") {
    return { arrFilteredPlayer: arrFilteredPlayer };
  } else if (selector === "Points") {
    return { arrFilteredPoints: arrFilteredPlayer };
  }
};

// app.getFilteredContestPlayer = (arrFiltresTab, players) => {
//   let arrFilteredPlayer = [];
//   let changes = {
//     nation: [],
//     credit: { min: [], max: [] },
//     team: [],
//     skill: [],
//   };
//   if (players) {
//     arrFiltresTab.map(({ transKey, id: aId, arrDetails }) => {
//       arrDetails.map((arr) => {
//         // arr.tempChecked ||
//         if (arr.tempChecked || arr.checked) {
//           // if (arrFilteredPlayer.length === 0) {
//           arrFilteredPlayer = players;
//           // }
//           //TODO:use enum
//           if (aId === config.enumTabsId.teams) {
//             changes.team.push(arr.id);
//           }

//           if (aId === config.enumTabsId.nationality) {
//             // FIXME: use enum

//             if (arr.id === config.enumNationalityIds.indian) {
//               changes.nation.push(1);
//             } else {
//               changes.nation.push(0);
//             }
//           }
//           if (aId === config.enumTabsId.creditRange) {
//             changes.credit.min.push(arr.min);
//             changes.credit.max.push(arr.max);
//           }
//           if (aId === config.enumTabsId.skill) {
//             changes.skill.push(arr.id);
//           }
//           if (changes.team.length) {
//             arrFilteredPlayer = players.filter((player) =>
//               changes.team.includes(player.teamid)
//             );
//           }
//           if (changes.nation.length) {
//             arrFilteredPlayer = arrFilteredPlayer.filter((player) =>
//               changes.nation.includes(parseInt(player.isfp))
//             );
//           }

//           if (changes.credit.min.length) {
//             arrFilteredPlayer = arrFilteredPlayer.filter((player) => {
//               for (let i = 0; i < changes.credit.min.length; i++) {
//                 if (
//                   changes.credit.min[i] <= parseInt(player.value) &&
//                   parseInt(player.value) <= changes.credit.max[i]
//                 ) {
//                   return player;
//                 }
//               }
//             });
//           }
//           if (changes.skill.length) {
//             arrFilteredPlayer = arrFilteredPlayer.filter((player) =>
//               changes.skill.includes(parseInt(player.sklid))
//             );
//           }
//         }
//       });
//     });
//     console.log(changes);
//     console.log(arrFiltresTab);
//     console.log(arrFilteredPlayer);
//     arrFilteredPlayer.sort((a, b) => b.ovrpoint - a.ovrpoint);
//   }

//   return { arrFilteredPlayer: arrFilteredPlayer };
// };

// app.getFilteredContestPoints = (arrFiltresTab, points) => {
//   let arrFilteredPoints = [];
//   let changes = {
//     nation: [],
//     credit: { min: [], max: [] },
//     team: [],
//   };
//   if (points) {
//     arrFiltresTab.map(({ transKey, arrDetails }) => {
//       arrDetails.map((arr) => {
//         if (arr.tempChecked || arr.checked) {
//           if (arrFilteredPoints.length === 0) {
//             arrFilteredPoints = points;
//           }
//           if (transKey === "teams") {
//             changes.team.push(arr.id);
//           }
//           if (transKey === "nationality") {
//             changes.nation.push(arr.id - 1);
//           }
//           if (transKey === "creaditRange") {
//             changes.credit.min.push(arr.min);
//             changes.credit.max.push(arr.max);
//           }
//           if (changes.team.length) {
//             arrFilteredPoints = points.filter((point) =>
//               changes.team.includes(point.TeamId)
//             );
//           }
//           if (changes.nation.length) {
//             arrFilteredPoints = arrFilteredPoints.filter((point) =>
//               changes.nation.includes(parseInt(point.isfp))
//             );
//           }

//           if (changes.credit.min.length) {
//             arrFilteredPoints = arrFilteredPoints.filter((point) => {
//               for (let i = 0; i < changes.credit.min.length; i++) {
//                 if (
//                   changes.credit.min[i] <= parseInt(point.value) &&
//                   parseInt(point.value) <= changes.credit.max[i]
//                 ) {
//                   return point;
//                 }
//               }
//             });
//           }
//         }
//       });
//     });
//     arrFilteredPoints.sort((a, b) => b.OverallPoints - a.OverallPoints);
//   }

//   return { arrFilteredPoints: arrFilteredPoints };
// };

app.isValidValue = (val) => {
  let res = false;
  if (val !== undefined && val !== null && val !== "") {
    res = true;
  }
  return res;
};
app.processLeaderboardData = (oldData, newData) => {
  let mergedData = oldData;
  if (newData && newData.length) {
    mergedData = concat(oldData, newData);
  }
  return mergedData;
};
app.processUserRankDataManipulation = (leagueObj) => {
  const objCookie = app.getLoginCookie();
  let obj = {
    rno: 0,
    temid: leagueObj.temid ? leagueObj.temid : 0,
    temname: "",
    usrname: objCookie && objCookie.UserName ? objCookie.UserName : "",
    usrscoid: objCookie && objCookie.SocialId ? objCookie.SocialId : "",
    usrclnid: 1,
    rank: leagueObj.ovrank,
    points: leagueObj.ovpts,
    ftgdid: leagueObj.ftgdid ? leagueObj.ftgdid : 0,
    prfimg: objCookie && objCookie.ProfileURL ? objCookie.ProfileURL : "",
    trend: leagueObj?.trend,
  };
  return obj;
};
app.getTotalPointsOfTeam = (
  arrPlayers,
  arrUserTeam,
  jCaptain,
  jViceCaptain,
  jImpactPlayer,
  TeamGamedayId,
  jBoosterId,
  leagueObj,
  objUserTeam
) => {
  let jTotal = 0;
  app.noBoosteOption(leagueObj);
  for (let j = 0; j < (arrUserTeam || []).length; j++) {
    let jId = arrUserTeam[j];
    let isCaptain = false;
    let isViceCaptain = false;
    let isImpactPlayer = false;
    const objMain = app.getPlayerDetails(arrPlayers, jId, []);
    if (objMain) {
      if (objMain.Id === jCaptain) {
        isCaptain = true;
      } else if (jViceCaptain === objMain.Id) {
        isViceCaptain = true;
      } else if (jImpactPlayer === objMain.Id) {
        isImpactPlayer = true;
      }
      let jPoints = 0;
      if (
        (objMain.IsAnnounced === "P" || objMain.IsAnnounced === "IMP") &&
        objMain.PlyrGamedayId === TeamGamedayId
      ) {
        jPoints = Number(objMain.GamedayPoints);
        if (isCaptain) {
          //jPoints = config.enumBonus.captain * Number(objMain.GamedayPoints);
          if (
            TeamGamedayId == objUserTeam?.bst12gd &&
            leagueObj?.legid !== config.publicLeagueIds.knockout
          ) {
            jPoints =
              config.enumBonus.tripleCaptain * Number(objMain.GamedayPoints);
          } else {
            jPoints = config.enumBonus.captain * Number(objMain.GamedayPoints);
          }
        } else if (isViceCaptain) {
          jPoints =
            config.enumBonus.viceCaptain * Number(objMain.GamedayPoints);
        } else if (
          isImpactPlayer &&
          (TeamGamedayId == objUserTeam?.["bst2gd"] ||
            TeamGamedayId == objUserTeam?.gdid)
        ) {
          jPoints =
            config.enumBonus.impactPlayer * Number(objMain.GamedayPoints);
        }

        if (jBoosterId) {
          jPoints = app.getPlayerPoint(objMain, jBoosterId, jPoints);
        }

        if (jBoosterId) {
          const objRow =
            config.enumBoosterTexts[config.enumBoosterApiKey.bst3gd];
          if (objRow.id === jBoosterId) {
            jPoints = config.enumBonus.perish * jPoints;
          }
        }
        jTotal = jTotal + jPoints;
      }
    }
  }
  jTotal = Number(jTotal).toFixed(1);
  jTotal = jTotal ? Number(jTotal) : jTotal;
  return { jTotal };
};

app.getMatchdays = (
  arrRound,
  hasTeam,
  isFreez,
  renderType,
  TeamGamedayId,
  leagueObj,
  isMyRank
) => {
  let cookie = app.getLoginCookie();
  let jFixture = -1;
  let arrFilteredFixure = [];
  let fBreak = false;
  let fIsPointCalculationDone = app.isPointCalDone(arrRound);
  let isLockedAny = false;

  for (let jN = 0; jN < (arrRound || []).length; jN++) {
    let row = arrRound[jN];
    let rowFixture = row;
    let isIndexOfMatchdayId =
      hasTeam && hasTeam <= Number(rowFixture.TeamGamedayId);
    let jStatus = app.getFixtureStatusByRow(rowFixture);
    if (cookie && isIndexOfMatchdayId) {
      if (
        fIsPointCalculationDone &&
        (renderType === config.enumTeamRenderType.contest ||
          renderType === config.enumTeamRenderType.leaderboard)
      ) {
        if (jStatus !== config.enumFixtureType.isUpcomming) {
          arrFilteredFixure.push({ ...rowFixture });
          fBreak = true;
          jFixture = arrFilteredFixure.length - 1;
        }
      } else if (jStatus !== config.enumFixtureType.isUpcomming) {
        arrFilteredFixure.push({ ...rowFixture });
        fBreak = true;
        jFixture = arrFilteredFixure.length - 1;
      }

      if (
        jStatus !== config.enumFixtureType.isUpcomming &&
        jStatus !== config.enumFixtureType.isOpen
      ) {
        isLockedAny = true;
      }
    }
  }

  // for flexible 👇
  if (
    renderType === config.enumTeamRenderType.contest ||
    renderType === config.enumTeamRenderType.leaderboard
  ) {
    if (isLockedAny) {
      let arrRoundT = [];
      for (let j = 0; j < (arrFilteredFixure || []).length; j++) {
        const objRow = arrFilteredFixure[j];
        let jStatus = app.getFixtureStatusByRow(objRow);
        // if (jStatus !== config.enumFixtureType.isOpen) {
        if (
          (jStatus !== config.enumFixtureType.isUpcomming && isMyRank) ||
          (jStatus !== config.enumFixtureType.isOpen && !isMyRank)
        ) {
          arrRoundT.push({ ...objRow });
          jFixture = arrRoundT.length - 1;
        }
      }

      arrFilteredFixure = arrRoundT;
      if (renderType === config.enumTeamRenderType.leaderboard) {
        arrFilteredFixure.push({ isOverall: true });
      } else if (renderType === config.enumTeamRenderType.contest) {
        arrFilteredFixure.push({ isOverall: true });
      }

      if (
        leagueObj?.legid &&
        config.captainLeagueId.includes(leagueObj?.legid)
      ) {
        for (let j = 0; j < (arrFilteredFixure || []).length; j++) {
          const objRow = arrFilteredFixure[j];
          let jStatus = app.getFixtureStatusByRow(objRow);
          if (jStatus !== config.enumFixtureType.isOpen) {
            if (objRow?.isOverall) {
              jFixture = j;
            }
          }
        }
      }
    }
  }

  if (TeamGamedayId) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      if (TeamGamedayId === +row.TeamGamedayId) {
        jFixture = j;
        break;
      }
    }
  }
  if (jFixture === -1) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      let jStatus = app.getFixtureStatusByRow(row);
      // if (jStatus === config.enumFixtureType.isFinished || jStatus === config.enumFixtureType.isLock || jStatus === config.enumFixtureType.isEnded || jStatus === config.enumFixtureType.isAbandoned || jStatus === config.enumFixtureType.isOpen) {
      if (jStatus !== config.enumFixtureType.isUpcomming) {
        jFixture = j;
        // jGameDayId = row.GamedayId;
        // jPhaseId = row.PhaseId;
        //break;
      }
    }
  }

  // if (
  //   arrFilteredFixure[jFixture - 1]?.IsLive == 1 &&
  //   isMyRank &&
  //   leagueObj?.gdid == arrFilteredFixure[jFixture - 1]?.gdid
  // ) {
  //   jFixture = jFixture - 1;
  // }

  // new fix live swiper

  // add below fix in Men's IPL 👇
  let newJfix = 0;
  // let liveMatchLen =
  //   arrFilteredFixure.filter((ele) => ele.IsLive == 1)?.length - 1;
  // if (liveMatchLen < 0) {
  //   liveMatchLen = 0;
  // }
  // let index = arrFilteredFixure.findIndex(
  //   (x) => x?.Gameday === leagueObj?.gdid
  // );
  // if (isMyRank && arrFilteredFixure[index]?.IsLive == 0) {
  //   jFixture = index;
  // }
  // if (liveMatchLen >= 1) {
  //   newJfix = jFixture + liveMatchLen;
  // } else {
  //   newJfix = jFixture;
  // }
  arrFilteredFixure = arrFilteredFixure.filter(
    (arr) => arr.IsLive > 0 || arr.isOverall
  );

  let liveMatchFix = arrFilteredFixure?.filter((ele) => ele?.IsLive == 1);
  let compMatchFix = arrFilteredFixure?.filter((ele) => ele?.IsLive > 1);

  let liveIndex = arrFilteredFixure?.findIndex(
    (f) => f.Gameday == liveMatchFix[liveMatchFix?.length - 1]?.Gameday
  );
  let compIndex = arrFilteredFixure?.findIndex(
    (f) => f.Gameday == compMatchFix[compMatchFix?.length - 1]?.Gameday
  );

  if (liveMatchFix?.length) {
    newJfix = liveIndex;
  } else {
    newJfix = compIndex;
  }
  if (arrFilteredFixure?.length == 0) {
    arrFilteredFixure = arrRound.filter((f) => f.Gameday === hasTeam);
  }
  // console.log("jFixture", jFixture);

  return {
    arrFilteredFixure: arrFilteredFixure,
    jFixture: newJfix < 0 ? 0 : newJfix,
  };
};
app.isFixtureChanged = (
  arrFixtures,
  LiveFixture,
  AbandonedGameDayId,
  FreezeGamedayId,
  VersionMaster,
  objMixOld,
  JsVersion
) => {
  let isSame = true;
  for (let j = 0; j < arrFixtures.length; j++) {
    const objRow = arrFixtures[j];
    const jMdStatus = app.getFixtureStatusByRow(objRow);
    if (LiveFixture && LiveFixture.length) {
      const objRowLive = LiveFixture[0];
      const jMdStatusLive = app.getFixtureStatusByRow(objRowLive);
      if (
        jMdStatus !== jMdStatusLive &&
        objRow.TeamGamedayId === objRowLive.TeamGamedayId
      ) {
        isSame = false;
        break;
      }
    }
    if (
      FreezeGamedayId &&
      Number(objRow.IsActiveForNewUser) === 0 &&
      FreezeGamedayId === objRow.TeamGamedayId
    ) {
      isSame = false;
      break;
    } else if (!FreezeGamedayId && Number(objRow.IsActiveForNewUser) === 1) {
      isSame = false;
      break;
    }
    if (
      AbandonedGameDayId &&
      jMdStatus !== config.enumFixtureType.isAbandoned &&
      AbandonedGameDayId === objRow.TeamGamedayId
    ) {
      isSame = false;
      break;
    }
    /* else if (
      !AbandonedGameDayId &&
      jMdStatus === config.enumFixtureType.isAbandoned
    ) {
      isSame = false;
      break;
    } */
  }
  if (isSame) {
    let oldLiveFixture = null;
    let VersionMasterOld = -1;
    if (objMixOld) {
      oldLiveFixture = objMixOld.LiveFixture;
      VersionMasterOld = objMixOld.VersionMaster;
    }
    if (
      (VersionMasterOld !== -1 && VersionMaster !== VersionMasterOld) ||
      (oldLiveFixture &&
        oldLiveFixture.length &&
        !(LiveFixture && LiveFixture.length))
    ) {
      isSame = false;
    }
  }
  //
  const isWebView = app.isWebView();
  if (isWebView && objMixOld && objMixOld.JsVersion !== JsVersion) {
    window.location.reload();
  }
  //
  return isSame;
};
app.getMatchNames = (arrFixtures, jId, isAbandoned, trans) => {
  let sNames = "";
  let sMatchday = "";
  let arrNames = [];
  if (jId) {
    loop1: for (let j = 0; j < (arrFixtures || []).length; j++) {
      let objRow = arrFixtures[j];
      if (objRow.TeamGamedayId === jId) {
        for (let jN = 0; jN < (objRow.arrDetails || []).length; jN++) {
          let ele = objRow.arrDetails[jN];
          let fStatus = app.getFixtureStatusByMatches(ele);
          if (
            (isAbandoned && fStatus == config.enumFixtureType.isAbandoned) ||
            !isAbandoned
          ) {
            arrNames.push(
              `${ele.HomeTeamId ? ele.HomeTeamShortName : ""} ${
                trans && trans.vs ? trans.vs : "vs"
              } ${ele.AwayTeamId ? ele.AwayTeamShortName : ""}`
            );
          }
        }
        sMatchday = objRow.Matchday;
        break loop1;
      }
    }
    if (arrNames.length) {
      sNames = (
        trans.homeAbandonedMatch1
          ? trans.homeAbandonedMatch1
          : "We're abandoning the {{match1}} match"
      ).replace("{{match1}}", arrNames[0]);
      if (arrNames.length > 1) {
        sNames = (
          trans.homeAbandonedMatch2
            ? trans.homeAbandonedMatch2
            : "We're abandoning the {{match1}} and {{match2}} matches"
        )
          .replace("{{match1}}", arrNames[0])
          .replace("{{match2}}", arrNames[1]);
      }
    }
  }
  return {
    sMatchday: sMatchday,
    sNames: sNames,
  };
};
app.setErrorCode = (jStatusCode) => {
  let jErrorcode = config.enumErrorCode.normal;
  const arrToast = [403, 401, -999];
  const arrRedirect = [500, 400];
  if (arrToast.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isToast;
  } else if (arrRedirect.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isRedirect;
  }
  return jErrorcode;
};
app.getUTMParameters = (sUrl) => {
  const objUrl = core.getQueryParams(sUrl ? sUrl : window.location.href);
  let search = "";
  for (let sKey1 in objUrl) {
    const sKey = sKey1.toLowerCase();
    if (
      sKey.indexOf("utm_") > -1 ||
      config.enumWebView.common.includes(sKey) ||
      config.enumWebView.platform.includes(sKey)
    ) {
      const sValue = objUrl[sKey1];
      if (sValue && sValue !== "undefined") {
        if (!search) {
          search = "?";
        } else {
          search = `${search}&`;
        }
        search = `${search}${sKey1}=${sValue}`;
      }
    }
  }
  return search;
};
app.getGroupByValue = function (arr, sKey, value) {
  let jIndex = 0;
  for (let j = 0; j < arr.length; j++) {
    if (arr[j][sKey] === value) {
      jIndex = jIndex + 1;
    }
  }
  return jIndex;
};
app.scrollTop = () => {
  const $nodeParent = document.querySelector("#container");
  if ($nodeParent) {
    core.smoothScroll($nodeParent);
  }
};
app.getMembersFromLocal = (legObj) => {
  let res = null;
  const lastTime = core.getLocalStorageValue(config.cookie.timeStamp);
  if (lastTime) {
    const nowTime = new Date().getTime();
    if (config.jDelayStorage <= nowTime - lastTime) {
      core.removeLocalStorageValue(config.cookie.leaguesCount);
      core.removeLocalStorageValue(config.cookie.timeStamp);
    }
  }
  //
  let localMembers = core.getLocalStorageValue(config.cookie.leaguesCount);
  if (localMembers) {
    let parsedObj = JSON.parse(localMembers);
    let val = parsedObj[legObj.legid] ? parsedObj[legObj.legid] : 0;
    res = val > legObj.legmemb ? val : legObj.legmemb;
    if (val && val < legObj.legmemb) {
      res = val;
    }
    // console.log("~~~~~~~~~~ app.getMembersFromLocal : ", val, legObj.legmemb);
  } else {
    res = legObj.legmemb;
  }
  return res;
};
app.getPlayerDetailsByTeamId = (arrPlayers, jTeamId) => {
  let objPlayer = null;
  if (jTeamId) {
    objPlayer = arrPlayers && arrPlayers.find((ele) => ele.TeamId === jTeamId);
  }
  return objPlayer;
};
app.getBoosterStatus = (
  IsAccounting = 0,
  jBoosterGdId = 0,
  jGdId = -1,
  // arrOtherBoosters = [],
  objBooster,
  sKey,
  timerVal
) => {
  let jStatus = config.enumBoosterStatus.disable;
  // arrOtherBoosters.forEach((jMdId) => {
  //   if (jMdId === jGdId) {
  //     jStatus = config.enumBoosterStatus.notActive;
  //   }
  // });

  if (jStatus !== config.enumBoosterStatus.notActive) {
    if (IsAccounting === 0 && jBoosterGdId === 0) {
      //not started //unlimited
      jStatus = config.enumBoosterStatus.disable;
    } else if (IsAccounting === 1 && objBooster && objBooster[sKey]) {
      /* else if (IsAccounting === 0 && jBoosterGdId) {
      //used previous
      jStatus = config.enumBoosterStatus.used;
    } */
      //used in current
      return config.enumBoosterStatus.usedInCurrentTemp;
    } else if (IsAccounting === 1 && jBoosterGdId === 0) {
      //started not used //you can take
      jStatus = config.enumBoosterStatus.open;
    } else if ((IsAccounting === 1 || IsAccounting === 0) && jBoosterGdId) {
      //started and used //used
      if (jBoosterGdId === jGdId) {
        //used in current
        // jStatus = config.enumBoosterStatus.active;
        //API booster not getting disabled in OverlayConfirm after removing and selecting a new booster.
        jStatus = config.enumBoosterStatus.open;
      } else {
        //used previous
        jStatus = config.enumBoosterStatus.used;
      }
    }
  }

  // CHANGE HERE
  if (sKey && jStatus == config.enumBoosterStatus.open) {
    const { isPerish, isActive } = config.enumBoosterTexts[sKey];
    if (isPerish && !isActive) {
      jStatus = config.enumBoosterStatus.disable;
    }
  }

  if (sKey && jStatus != config.enumBoosterStatus.used) {
    const { isPerish, isActive, tillDate } = config.enumBoosterTexts[sKey];
    if (isPerish && isActive == config.perishDisableState) {
      // if (new Date(tillDate) < new Date(timerVal ?? config.CondDate)) {
      jStatus = config.enumBoosterStatus.isExpired;
      // }
    }
  }

  return jStatus;
};

app.getBoosterDetails = (
  objUserTeam,
  jCurrentMatchday,
  arrFixtures,
  objBooster,
  timerVal
) => {
  //boosterid   1  super transfer ,  2 imapct player, 3 double points
  const { isacct } = objUserTeam || {};

  let retVal = {};

  for (let i = 0; i < config.boosterArr.length; i++) {
    const booster = config.boosterArr[i];

    const bstgd = objUserTeam ? objUserTeam[booster] : undefined;

    // if (typeof bstgd == "undefined") {
    //   continue;
    // }

    let isacctV =
      config.enumBoosterApiKey.bst1gd == booster ||
      config.enumBoosterApiKey.bst11gd == booster
        ? isacct
        : 1;

    let jBoosterStatus = app.getBoosterStatus(
      isacctV,
      bstgd,
      jCurrentMatchday,
      // [bst2gd, bst3gd],
      objBooster,
      booster,
      timerVal
    );

    let objFixture = app.getMyFirstFixture(arrFixtures, bstgd);
    const objBosterData = {
      status: jBoosterStatus,
      objFixture: objFixture ? objFixture.fixture : null,
    };

    retVal[booster] = objBosterData;
  }

  // let jBoosterStatus = app.getBoosterStatus(
  //   isacct,
  //   bst1gd,
  //   jCurrentMatchday,
  //   // [bst2gd, bst3gd],
  //   objBooster,
  //   config.enumBoosterApiKey.bst1gd
  // );
  // let objFixture = app.getMyFirstFixture(arrFixtures, bst1gd);
  // const objUnlimitted = {
  //   status: jBoosterStatus,
  //   objFixture: objFixture ? objFixture.fixture : null,
  // };
  // jBoosterStatus = app.getBoosterStatus(
  //   1,
  //   bst2gd,
  //   jCurrentMatchday,
  //   objBooster,
  //   config.enumBoosterApiKey.bst2gd
  // );
  // objFixture = app.getMyFirstFixture(arrFixtures, bst2gd);
  // const objImpactPlayer = {
  //   status: jBoosterStatus,
  //   objFixture: objFixture ? objFixture.fixture : null,
  // };
  // jBoosterStatus = app.getBoosterStatus(
  //   1,
  //   bst3gd,
  //   jCurrentMatchday,
  //   objBooster,
  //   config.enumBoosterApiKey.bst3gd
  // );
  // objFixture = app.getMyFirstFixture(arrFixtures, bst3gd);
  // const objDoublePlayer = {
  //   status: jBoosterStatus,
  //   objFixture: objFixture ? objFixture.fixture : null,
  // };
  // return {
  //   [config.enumBoosterApiKey.bst1gd]: objUnlimitted,
  //   [config.enumBoosterApiKey.bst2gd]: objImpactPlayer,
  //   [config.enumBoosterApiKey.bst3gd]: objDoublePlayer,
  // };

  // console.log("~ retVal", retVal);
  return retVal;
};
app.isImpactPlayer = (objUserTeam, objBooster, jCurrentMatchday) => {
  let flag = false;
  if (
    (objUserTeam &&
      objUserTeam[config.enumBoosterApiKey.bst2gd] === jCurrentMatchday) ||
    (objBooster &&
      objBooster[config.enumBoosterApiKey.bst2gd] === jCurrentMatchday)
  ) {
    flag = true;
  }
  return flag;
};
app.isImpactPlayerById = (jBoosterId) => {
  let flag = false;
  const objRow = config.enumBoosterTexts[config.enumBoosterApiKey.bst2gd];
  if (jBoosterId === (objRow && objRow.id)) {
    flag = true;
  }
  return flag;
};
app.getCurrentGamedayBooster = (objUserTeam, jCurrentMatchday) => {
  let objBooster = null;
  if (objUserTeam) {
    for (let sKey in config.enumBoosterTexts) {
      const objRow = config.enumBoosterTexts[sKey];
      const jGdId = objUserTeam[sKey];
      if (jGdId && Number(jGdId) === Number(jCurrentMatchday)) {
        objBooster = objRow;
        break;
      }
    }
  }
  return objBooster;
};
app.getBoosterById = (jBoosterId) => {
  let objBooster = null;
  for (let sKey in config.enumBoosterTexts) {
    const objRow = config.enumBoosterTexts[sKey];
    const jGdId = objRow.id;
    if (jGdId && Number(jGdId) === Number(jBoosterId)) {
      objBooster = objRow;
      break;
    }
  }
  return objBooster;
};
app.getBoosterByKey = (sKey) => {
  const objRow = config.enumBoosterTexts[sKey];
  let objBooster = objRow;
  return objBooster;
};
app.setLeaderboardByTeamId = (contestLeaderboardRes, temid) => {
  let arrLeaderBoard = [...contestLeaderboardRes];
  let isFound = false;
  const jIndexLeaderboard = contestLeaderboardRes.findIndex((ele) => {
    return temid === ele.temid;
  });
  if (jIndexLeaderboard !== -1) {
    arrLeaderBoard[jIndexLeaderboard] = {
      ...arrLeaderBoard[jIndexLeaderboard],
      islocked: 1,
    };
    isFound = true;
  }
  return {
    arrLeaderBoard,
    isFound,
  };
};
app.groupBadges = (badges, key) => {
  let arrMstBdg = [];
  const arr = badges.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});

  Object.keys(arr).map((i) => {
    arrMstBdg = [
      ...arrMstBdg,
      {
        MasterId: i,
        ...arr[i][0],
        badges: arr[i],
      },
    ];
  });
  // console.log(arrMstBdg);
  arrMstBdg = arrMstBdg.sort((a, b) => a.Order - b.Order);

  arrMstBdg?.map((bg) => {
    if (bg?.MasterId == "53") {
      bg.badges = bg.badges.sort((a, b) => a.Order - b.Order);
    }
  });

  return arrMstBdg;
};
app.isNoBadge = (unLockedBadges) => {
  let temp = false;
  unLockedBadges.map((a) => {
    return a.badges.map(({ isActive }) => {
      if (isActive) {
        temp = true;
      }
    });
  });

  return temp;
};

app.getBdgForOverLat = (unLockedBadges, msId) => {
  let main = [];
  let left = [];
  let activated = [];
  let smallOver = [];
  let activatedId = [];
  let tempMsID = 0;
  let bdg = [];

  bdg = unLockedBadges.filter((a) => a.MasterId === msId).map((a) => a.badges);

  unLockedBadges.map(({ badges }) => {
    badges.map((a) => {
      if (a.Id === msId) {
        activatedId = a;
      }
    });
  });

  if (bdg.length) {
    activated.push(...bdg[0].filter((a) => a.isActive));
    main = bdg[0].filter((a) => !a.isActive).slice(0, 1);
    left = bdg[0].filter((a) => !a.isActive).slice(1);
    smallOver = bdg[0].filter(
      (a) =>
        (a.Type === "NA" && a.IsProgress === 0) ||
        (a.IsProgress === 2 && a.Name === "The Patriot")
    );
  }

  if (config.boosterBadgesId?.includes(msId)) {
    tempMsID = config.enumBadgeDetails[msId].MasterId;

    bdg = unLockedBadges
      .filter((a) => a.MasterId === tempMsID)
      .map((a) => a.badges);
    main = bdg[0].filter((a) => a.Id === msId);
    left = bdg[0].filter((a) => !a.isActive && a.Id !== msId);
    activated.push(...bdg[0].filter((a) => a.isActive));
  }

  return { main, left, activated, smallOver, activatedId };
};

app.getBdgForAll = (unLockedBadges) => {
  let left = [];
  let active = [];
  let activeU = [];
  let endLeague = [];

  // console.log(unLockedBadges);

  unLockedBadges.map(({ badges }) => {
    badges.map((a) => {
      const newEot = config.enumBadgeDetails[a.Id]
        ? config.enumBadgeDetails[a.Id]
        : 1;

      const { eot } = newEot;

      if (a.isActive) {
        activeU.push(a);
      } else if (eot) {
        endLeague.push(a);
      } else {
        left.push(a);
      }
    });
  });

  left = app.groupBadges(left, "MasterId");
  active = app.groupBadges(activeU, "MasterId");
  endLeague = app.groupBadges(endLeague, "MasterId");

  return {
    left,
    active,
    endLeague,
    activeU,
  };
};

app.getUserBadgesList = (badges, bdgUserVal) => {
  let unLockedBadges = [];
  let unLockedType = [];
  let unLockedAll = [];
  let msIdList = [];
  let msIdListVal = [];
  let count = {
    myCount: 0,
    allCount: 0,
  };

  count.allCount = badges.length;

  Object.keys(bdgUserVal).map((a) => {
    if (bdgUserVal[a] && a !== "notifyBadges") {
      unLockedBadges.push(...bdgUserVal[a]);
    }
  });

  // console.log(unLockedBadges);

  badges.map((badge) => {
    unLockedBadges.map(({ bgmastid, usrval }) => {
      const badgeDetails =
        config.enumBadgeDetails[badge && badge.Id ? badge?.Id : 1];
      if (badgeDetails) {
        const { Id, IsProgress, MasterId, isSpec, eot } =
          config.enumBadgeDetails[badge.Id];

        if (bgmastid === MasterId) {
          if (isSpec === 1) {
            if (usrval === badge.MinVal) {
              unLockedType.push({ ...badge, isActive: true, usrval });
              count.myCount += 1;
            }
          } else if (isSpec === 2) {
            if (usrval === badge.MinVal) {
              unLockedType.push({ ...badge, isActive: true, usrval });
              count.myCount += 1;
            }
          } else {
            if (usrval >= badge.MinVal) {
              unLockedType.push({ ...badge, isActive: true, usrval });
              count.myCount += 1;
            }
          }
        }
      }
    });
    if (badge.MasterId === config.enumBadgeDetails[49].Id) {
      if (count.myCount >= badge.MinVal) {
        unLockedType.push({
          ...badge,
          isActive: true,
          // usrval: count.myCount,
          usrval: unLockedType.length,
        });
        // count.myCount += 1;
      }
    }
  });

  msIdList = unLockedType.map((a) => {
    return a.Id;
  });

  unLockedBadges.map(({ bgmastid, usrval }) => {
    msIdListVal[bgmastid] = usrval;
  });

  // msIdListVal[config.enumBadgeDetails[49].Id] = count.myCount;
  msIdListVal[config.enumBadgeDetails[49].Id] = unLockedType.length;

  badges.map((badge) => {
    if (msIdList.includes(badge.Id)) {
      const res = unLockedType.filter((a) => a.Id === badge.Id);
      unLockedAll.push(...res);
    } else {
      unLockedAll.push({
        ...badge,
        isActive: false,
        usrval: msIdListVal[badge.MasterId] || 0,
      });
    }
  });

  unLockedAll = app.groupBadges(unLockedAll, "MasterId");

  return { unLockedType: unLockedAll, count };
};

app.getCloseToWinning = (unLockedBadges) => {
  if (unLockedBadges) {
    let disp = [];
    let active = [];

    for (let i = 0; i < unLockedBadges.length; i++) {
      const badge = unLockedBadges[i];

      for (let j = 0; j < badge.badges.length; j++) {
        const a = badge.badges[j];
        if (
          // a.isActive &&
          a.MasterId !== config.enumBadgeDetails[49].Id &&
          a.MasterId !== config.enumBadgeDetails[58].Id &&
          config.enumBadgeDetails[a.Id]?.isSpec !== 2 &&
          !config.enumBadgeDetails[a.Id]?.eot
        ) {
          active.push(badge);
          break;
        }
      }
    }

    active.map(({ badges }) => {
      if (badges.filter((a) => !a.isActive)[0]) {
        disp.push(badges.filter((a) => !a.isActive)[0]);
      }
    });

    return disp.splice(0, 3);
  }
};

app.getNotifyBadges = (arrBadges, arrUserBadges) => {
  let unLockedBadges = [];
  let notifCount = 0;

  if (arrBadges && arrUserBadges) {
    let val = [];
    val = app.getUserBadgesList(arrBadges, arrUserBadges);
    unLockedBadges = val.unLockedType;
  }

  let temp = [];
  unLockedBadges.map(({ badges }) => {
    badges.map((a) => {
      if (a.isActive) {
        temp.push(a.Id);
      }
    });
  });

  let nots =
    arrUserBadges && arrUserBadges.notifyBadges
      ? arrUserBadges.notifyBadges
      : [];

  if (temp.length - nots.length > 0) {
    notifCount = temp.length - nots.length;
  }

  let notsUp = temp.filter((a) => !nots.includes(a));

  nots = [...new Set([...nots, ...temp])];

  return { notsUp, nots, notifCount };
};
app.isWebView = (location) => {
  let sSearch = location
    ? location
    : window.location && window.location.search
    ? window.location.search
    : "";
  if (sSearch && sSearch.toLowerCase().includes(config.enumWebView.common)) {
    return true;
  }
  return false;
};
app.getAppType = () => {
  let qs = window.location.search.toLowerCase();
  let urlParams = new URLSearchParams(qs);
  return urlParams.get("apptype");
};
app.add_years = (dt, n) => {
  return new Date(dt.setFullYear(dt.getFullYear() + n));
};
app.mergeBadesData = (arrOld, arrNew, sKey) => {
  const arrBoosterBadge = arrOld.filter((ele) => {
    return ele.bgmastid === config.enumBadgeMasterId.msId53;
  });
  arrNew &&
    arrNew.forEach((ele, jN) => {
      const jIndex = core.getIndexOfArrayByValue(
        arrOld,
        "bgmastid",
        ele.bgmastid
      );
      if (jIndex === -1) {
        arrOld.push({ ...ele });
      } else {
        if (ele.bgmastid === config.enumBadgeMasterId.msId53) {
          let isMatch = false;
          arrBoosterBadge &&
            arrBoosterBadge.forEach((eleBadge) => {
              const { usrval } = eleBadge;
              if (usrval === ele.usrval) {
                isMatch = true;
              }
            });
          if (!isMatch) {
            arrOld.push({ ...ele });
          }
        } else {
          let isSkip = false;
          if (sKey === "leagueBadges") {
            if (arrOld[jIndex].usrval > ele.usrval) {
              isSkip = true;
            }
          }
          if (!isSkip) {
            arrOld[jIndex] = { ...ele };
          }
        }
      }
    });
  return { [sKey]: [...arrOld] };
};

app.toErrorMap = (errors) => {
  const errMap = {};
  errors.map(({ field, message }) => {
    errMap[field] = message;
  });
  console.log("~ errMap", errMap);

  return errMap;
};

app.trimVal = (values) => {
  Object.keys(values).map((key) => {
    if (key !== "password" && key != "dob" && typeof values[key] !== "number") {
      values[key] = values[key]?.trim();
    }
  });

  return values;
};

app.isObjNotEmpty = (obj) => {
  return obj && Object.keys(obj).length > 0;
};

app.genSelectList = () => {};

app.getSortedList = (arr, objBoosterDetails) => {
  let left = [];
  let completed = [];
  let active = [];
  let finalList = [];

  let map = new Map(Object.entries(objBoosterDetails));
  let sortedMap = new Map(
    [...map.entries()].sort((a, b) => {
      let ageA = a[1].objFixture ? a[1].objFixture.Gameday : Number.MAX_VALUE;
      let ageB = b[1].objFixture ? b[1].objFixture.Gameday : Number.MAX_VALUE;
      return ageB - ageA;
    })
  );
  let newArr = Array.from(sortedMap.keys());

  for (let i = 0; i < newArr?.length; i++) {
    const boost = newArr[i];
    const objBoosterRow = objBoosterDetails && objBoosterDetails[boost];
    const { status } = objBoosterRow || {};
    const { isActive } = config.enumBoosterTexts[boost];

    if (
      status == config.enumBoosterStatus.used ||
      status == config.enumBoosterStatus.active ||
      status == config.enumBoosterStatus.isExpired
    ) {
      completed.push(boost);
    } else if (isActive) {
      active.push(boost);
    } else {
      left.push(boost);
    }
  }

  finalList = [...active, ...left, ...completed];
  return finalList;
};
app.skillCheck = (SkillId, SkillIdConf, isUnCap, IS_FP) => {
  if (SkillId == SkillIdConf) {
    return true;
  } else if (!Number(IS_FP) && SkillIdConf == config.specialSkill.isUncap) {
    return true;
  } else if (Number(IS_FP) && SkillIdConf == config.specialSkill.isOverSeas) {
    return true;
  }
};

app.getFromGamerCard = (objUserTeam) => {
  let retVal = [];
  for (let i = 0; i < config.boosterArr.length; i++) {
    const booster = config.boosterArr[i];

    let bstgd = objUserTeam && objUserTeam[booster];
    // CHANGE HERE
    // if (typeof bstgd == "undefined") {
    //   bstgd = null;
    // }

    retVal[booster] = bstgd;
  }

  return retVal;
};

app.getPlayerPoint = (objMain, objSelectedBoosterId, value) => {
  for (let i = 0; i < config.boosterArr.length; i++) {
    const booster = config.boosterArr[i];

    const { isUnCap, IS_FP } = objMain || {};

    if (
      objSelectedBoosterId == config.enumBoosterTexts[booster].id
      //  &&
      // config.enumBoosterTexts[booster].isPerish
    ) {
      if (
        app.skillCheck(
          objMain?.SkillId,
          config.enumBoosterTexts[booster].SkillId,
          isUnCap,
          IS_FP
        )
      ) {
        // console.log(objMain);
        return config.enumBonus.perish * value;
      }
    }
  }

  return value;
};

app.isBoosterExpired = (
  objUserTeam,
  jCurrentMatchday,
  arrFixtures,
  timerVal
) => {
  let result = false;
  const objBoosterDetails = app.getBoosterDetails(
    objUserTeam,
    jCurrentMatchday,
    arrFixtures,
    null,
    timerVal
  );

  config.boosterArr.map((id) => {
    const objBoosterRow = objBoosterDetails && objBoosterDetails[id];
    const { status } = objBoosterRow || {};

    if (config.enumBoosterTexts[id].isActive) {
      if (
        status == config.enumBoosterStatus.used ||
        status == config.enumBoosterStatus.active ||
        status == config.enumBoosterStatus.isExpired
      ) {
        result = false;
      } else {
        result = true;
      }
    }
  });

  return result;
};

app.fetchLivePlayers = (recentFixture = []) => {
  let res = false;
  if (
    recentFixture?.status == config.enumFixtureType.isOpen &&
    recentFixture?.fixture?.IsLineupAnnounced
  ) {
    res = true;
  }

  return res;
};

app.getNameFormValue = (value, options) => {
  return options?.find((a) => a.id == value)?.name;
};

app.boosterValUpdate = (arrBoostersConstraint) => {
  if (arrBoostersConstraint) {
    arrBoostersConstraint.forEach((element) => {
      if (config.enumBoosterTexts[element.Name]) {
        config.enumBoosterTexts[element.Name].id = element.Id;
      }

      if (
        element.IsActive &&
        element.Id == config.enumBoosterTexts[element.Name].id &&
        config.enumBoosterTexts[element.Name].isPerish
      ) {
        config.enumBoosterTexts[element.Name].isActive = true;
        if (element.IsActive == config.perishDisableState) {
          config.enumBoosterTexts[element.Name].isActive = 2;
        }

        let timeMain = core.convertTimeToOffsetNew(
          element.ExpDateTime,
          config.offSetToAdd
        );

        config.enumBoosterTexts[element.Name].tillDate = timeMain;

        // config.enumBoosterTexts[element.Name].tillDate =
        //   element.ExpDateTime;
      }
    });
  }
};

app.isPerishBoosterSelected = (objBooster) => {
  const { id } = objBooster || {};
};

app.getLiveMatch = (arrFix) => {
  let liveGamedays = [];
  if (arrFix) {
    liveGamedays = findLast(arrFix, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return (
        status == config.enumFixtureType.isLock ||
        status == config.enumFixtureType.isLive ||
        status == config.enumFixtureType.isEnded
      );
    });
  }

  return liveGamedays;
};

app.getLiveCompletedMatch = (arrFix) => {
  let liveGamedays = [];
  if (arrFix) {
    liveGamedays = findLast(arrFix, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return (
        status == config.enumFixtureType.isLock ||
        status == config.enumFixtureType.isLive ||
        status == config.enumFixtureType.isEnded ||
        status == config.enumFixtureType.isFinished ||
        status == config.enumFixtureType.isAbandoned ||
        status == config.enumFixtureType.isPostponed ||
        status == config.enumFixtureType.isPostMatchAbandoned
      );
    });
  }

  return liveGamedays;
};

app.createObjForLive = (fix, userTeam) => {
  let data = {
    jCaptain: 0,
    jVCaptain: 0,
    bcapt: 0,
    TeamGamedayId: 0,
    boosterid: 0,
  };

  if (userTeam && fix) {
    data.jCaptain = userTeam?.mcapt;
    data.jVCaptain = userTeam?.vcapt;
    data.bcapt = userTeam?.bcapt;
    data.TeamGamedayId = fix?.TeamGamedayId;

    let objBoosterId = app.getCurrentGamedayBooster(
      userTeam,
      fix?.TeamGamedayId
    );

    data.boosterid = objBoosterId?.id ?? null;
  }

  return data;
};

app.selectefBooster = (id) => {
  let booster = null;
  if (id) {
    for (let sKey in config.enumBoosterTexts) {
      const objRow = config.enumBoosterTexts[sKey];

      if (Number(id) === Number(objRow?.id)) {
        booster = objRow;
        break;
      }
    }
  }

  return booster;
};

app.captainContestVisible = (lg, jFixtures) => {
  let isShow = true;

  if (lg?.legid == config.publicLeagueIds.captain) {
    isShow = config.captainGdDates.captain > jFixtures;
  } else if (lg?.legid == config.publicLeagueIds.vCaptain) {
    isShow = config.captainGdDates.vCaptain > jFixtures;
  } else if (lg?.legid == config.publicLeagueIds.knockout) {
    isShow = config.captainGdDates.knockOut > jFixtures;
  }

  return isShow;
};

app.genrateUrl = (leagueVal) => {
  let val = "";
  if (leagueVal == config.publicLeagueIds.captain) {
    val = "captain-";
  } else if (leagueVal == config.publicLeagueIds.vCaptain) {
    val = "vcaptain-";
  } else if (leagueVal == config.publicLeagueIds.knockout) {
    val = "knockout-";
  }
  return val;
};

app.getPrizesDetails = (objContest, imgBase, jFixtures, arrFixtures) => {
  let prize = {
    title: "",
    img: "",
    sClass: "",
    date: "",
    lText: "Starting on ",
  };
  // @Viishesh Jain - Knockout

  if (objContest?.legid == config.publicLeagueIds.captain) {
    prize.title = "tataHar";
    prize.img = config.IMG_BASE + "tata-punch.png";
    prize.sClass = "m11c-contest__box-thumb-car";
    let date =
      arrFixtures?.find((f) => f.TeamGamedayId == config.captainGdDates.captain)
        ?.Deadlinedate ?? "";

    prize.date = core.dateFormat(date, "dS, mmmm");

    if (config.captainGdDates.captain <= jFixtures) {
      prize.lText = "Started on ";
    }
  } else if (objContest?.legid == config.publicLeagueIds.vCaptain) {
    prize.title = "tataHar";
    prize.img = config.IMG_BASE + "tata-punch.png";
    prize.sClass = "m11c-contest__box-thumb-car";
    let date =
      arrFixtures?.find(
        (f) => f.TeamGamedayId == config.captainGdDates.vCaptain
      )?.Deadlinedate ?? "";

    prize.date = core.dateFormat(date, "dS, mmmm");

    if (config.captainGdDates.vCaptain <= jFixtures) {
      prize.lText = "Started on ";
    }
  } else if (objContest?.legid == config.publicLeagueIds.knockout) {
    prize.title = "playoffLeagueHeadReward";
    prize.sClass = "m11c-contest__box-thumb-img-po";
    prize.img = config.IMG_BASE + "playoff-prize.png";
    let date =
      arrFixtures?.find(
        (f) => f.TeamGamedayId == config.captainGdDates.knockOut
      )?.Deadlinedate ?? "";

    prize.date = core.dateFormat(date, "dS, mmmm");

    if (config.captainGdDates.knockOut <= jFixtures) {
      prize.lText = "Started on ";
    }
  } else if (objContest?.legid == config.publicLeagueIds.global) {
    prize.title = "Signed Merchandise & Vouchers";
    prize.img = config.IMG_BASE + "prizes-blue.svg";
    prize.sClass = "m11c-contest__box-thumb-car";
    prize.date = "gDate";
    prize.lText = "Started on ";
  } else {
    prize.title = "marutiSuzukiCar";
    prize.img = imgBase;
    prize.date = "gDate";
    prize.lText = "Started on ";
  }

  return prize;
};

app.selfClickLb = (objContest, jFixtures) => {
  let resp = false;
  if (
    config.captainLeagueId.includes(objContest?.legid) ||
    objContest?.legid == config.publicLeagueIds.knockout
  ) {
    if (
      objContest?.legid == config.publicLeagueIds.captain &&
      config.captainGdDates.captain > jFixtures
    ) {
      resp = true;
    } else if (
      objContest?.legid == config.publicLeagueIds.vCaptain &&
      config.captainGdDates.vCaptain > jFixtures
    ) {
      resp = true;
    } else if (
      objContest?.legid == config.publicLeagueIds.knockout &&
      config.captainGdDates.knockOut > jFixtures
    ) {
      resp = true;
    } else {
      resp = false;
    }
  } else {
    resp = false;
  }
  return resp;
};

app.calcMatchPoints = (currGd = 12, leagueObj = { legid: 3 }, ftgdid = 2) => {
  let matchDayPts = 0;
  let subVal = config.captainGdDates.captain;
  if (leagueObj?.legid == config.publicLeagueIds.captain) {
    subVal = config.captainGdDates.captain;
  } else if (leagueObj?.legid == config.publicLeagueIds.vCaptain) {
    subVal = config.captainGdDates.vCaptain;
  } else if (leagueObj?.legid == config.publicLeagueIds.knockout) {
    subVal = config.captainGdDates.knockOut;
  }

  if (ftgdid < subVal) {
    matchDayPts = currGd - subVal;
  } else {
    matchDayPts = currGd - ftgdid;
  }
  let res = Math.abs(matchDayPts);
  return res;
};

// app.calcMatchPoints();
// window.testFunc = app.calcMatchPoints;

app.noBoosteOption = (legObj) => {
  if (legObj?.legid == config.publicLeagueIds.knockout) {
    config.enumBonus = config.enumNoBonus;
  } else {
    config.enumBonus = config.enumBonusBak;
  }
};

app.setMoreLinkConfig = () => {
  config.morePage = config.configData?.morePage;
  config.enumBadgeDetails = config.configData?.enumBadgeDetails;

  if (app.isWebView()) {
    config.morePage = config.configData?.morePageWebView;
  }
};

// whether abandoned status is PRE or POST Match
app.getAbandonedMatchStatus = (status, obj) => {
  let jStatus = status == config.enumFixtureType.isAbandoned;
  return jStatus;
};

// app.gaEventTrigger = (eventProperties) => {
//   if (window.gtag) {
//     window.gtag("event", "fantasy", eventProperties);
//   }
// };
app.gaEventTrigger = (eventProperties) => {
  if (window.dataLayer) {
    window.gtag("event", "fantasy", eventProperties);
    window.gtag(("event", eventProperties.event, eventProperties));
  }
};

app.sortPlayersBySkill = (players) => {
  const skillOrder = [4, 1, 3, 2];

  // Create a map to store the index of each skillId
  const skillIndexMap = {};
  skillOrder.forEach((skillId, index) => {
    skillIndexMap[skillId] = index;
  });

  // Sort the players array based on the skillId index in skillOrder
  players.sort((a, b) => {
    const skillIndexA = skillIndexMap[a.SkillId];
    const skillIndexB = skillIndexMap[b.SkillId];
    return skillIndexA - skillIndexB;
  });

  return players;
};

export default app;
